import { zod } from '@acme/core'
import dayjs from 'dayjs'
import { z } from 'zod'
import ApiService from '../api.service'

const dateString = z
    .date()
    .or(z.string())
    .transform(val => dayjs(val, 'YYYY-MM-DD', true).format('YYYY-MM-DD'))

const diaMes = z.coerce
    .number()
    .int()
    .min(1, 'O dia deve ser no mínimo 1')
    .max(31, 'O dia deve ser no máximo 31')

export const CreateTrocaInicioPontoSchema = zod.TrocaInicioPontoSchema.omit({
    id: true,
    createdAt: true,
}).extend({
    diaAnterior: diaMes,
    diaInicioPonto: diaMes,
    dataInicial: dateString,
    dataFinal: dateString,
    proximaDataInicial: dateString,
    proximaDataFinal: dateString,
})

export type TrocaInicioPonto = z.infer<typeof CreateTrocaInicioPontoSchema> & {
    id: number
    createdAt: string
}

export const trocaInicioPonto = new ApiService<TrocaInicioPonto>(
    'troca-inicio-ponto',
)
